module.exports = __webpack_public_path__ + "img/BATERY.d0238ce7.svg";